import { v4 as uuid } from 'uuid'
import { useLiveQuery } from 'dexie-react-hooks'
import { itemListDB } from '@/dexieDatabases/ItemListDatabase'
import itemListJson from '@/resources/itemShop.json'

const useSelectedItem = () => {
  const shopItemList = useLiveQuery(() => itemListDB.shopItems.toArray(), []) ?? []

  const getTotalCost = () => {
    let result = 0
    shopItemList
      ?.filter((s) => s.enabled)
      .forEach((s) => {
        result += (itemListJson.itemShop.find((e) => e.name === s.name)?.price ?? 0) * s.count
      })
    return result
  }

  const add = async (name: string, count: number) => {
    await itemListDB.shopItems.add({ uuid: uuid(), name: name, count: count, enabled: true })
  }

  const applyChange = async (uuid: string, name: string, count: number) => {
    const target = await itemListDB.shopItems.where({ uuid: uuid }).first()
    if (target?.id !== undefined) {
      await itemListDB.shopItems.update(target.id, { name, count })
    }
  }

  const setEnabled = async (uuid: string, b: boolean) => {
    const target = await itemListDB.shopItems.where({ uuid: uuid }).first()
    if (target?.id !== undefined) {
      await itemListDB.shopItems.update(target.id, { enabled: b })
    }
  }

  const remove = async (uuid: string) => {
    const target = await itemListDB.shopItems.where({ uuid: uuid }).first()
    if (target?.id !== undefined) {
      await itemListDB.shopItems.delete(target.id)
    }
  }

  const clear = async () => {
    await itemListDB.delete()
    await itemListDB.open()
  }

  return { shopItemList, getTotalCost, add, applyChange, setEnabled, remove, clear }
}

export { useSelectedItem }
